import { FormControl, FormGroup } from '@angular/forms';
import { ExtractFormControl } from '@libs/utils';

export interface PerioConfigFormGroup {
  pocketDepth: FormGroup<PerioMeasurementFormGroup<number | undefined>>;
  bleedingOnProbing: FormGroup<PerioMeasurementFormGroup<boolean>>;
  suppuration: FormGroup<PerioMeasurementFormGroup<boolean>>;
  rec: FormGroup<PerioMeasurementFormGroup<number | undefined>>;
}

export interface PerioMeasurementFormGroup<T> {
  distal: FormControl<T>;
  central: FormControl<T>;
  mesial: FormControl<T>;
}

export type PerioMeasurementSurface<T = number> = keyof PerioMeasurementFormGroup<T>;

export type PerioConfigFormGroupValueType = ExtractFormControl<PerioConfigFormGroup>;

export enum TargetIndexMovement {
  Prev = -1,
  None = 0,
  Next = 1,
}
